import { frontendURL } from '../../../../helper/URLHelper';

const calendar = accountId => ({
  parentNav: 'calendars-nav',
  routes: [
    'calendar_meetings',
    'calendar_meeting_list',
    'upcomming_appointment_list',
    'calendar_reports',
  ],
  menuItems: [
    {
      icon: 'calendar_star',
      label: 'SESSION', // SESSION
      toState: frontendURL(`accounts/${accountId}/calendar/list`),
      toStateName: 'calendar_meeting_list',
    },
    {
      icon: 'calendar-check',
      label: 'APPOINTMENT_LIST',
      toState: frontendURL(`accounts/${accountId}/calendar/appointments`),
      toStateName: 'upcomming_appointment_list',
    },
    {
      icon: 'graph_bar',
      viewBox: '0 0 16 16',
      label: 'CALENDAR_REPORTS',
      toState: frontendURL(`accounts/${accountId}/calendar/reports`),
      toStateName: 'calendar_reports',
    },
  ],
});

export default calendar;
